<template>
    <div class="auto-list form-control">
        <!-- optional indicators -->
        <i class="fa fa-spinner fa-spin" v-if="loading"></i>
        <template v-else>
            <i class="fa fa-search" v-show="isEmpty"></i>
            <i class="fa fa-times" v-show="isDirty" @click="reset"></i>
        </template>

        <!-- the input field -->
        <input type="hidden" name="entity_id" value="0" v-model="entity_id" />
        <input name="entity" class="comment-entity" type="text" placeholder="Type in Name" autocomplete="off" v-model="query" @keydown.down.prevent="down" @keydown.up.prevent="up" @keydown.enter.prevent="hit" @focus="preUpdate" @keydown.right="hit" @keydown.esc="reset" @blur="reset" @input="preUpdate"/>

        <!-- the list -->
        <ul v-show="hasItems">
            <li v-for="(item, index) in items" :class="activeClass(index)" @mousedown="hit" @mousemove="setActive(index)">
                <span v-text="item.name"></span>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        props: {
            id: { default : '' }
        },

        mixins: [require('../methods/vue-typeahead.js')], // vue@1.0.21-

        data () {
            return {
                // Currently Selected
                selected: false,
                entity_id: 0,

                // The source url
                // (required)
                src: '/company/' + this.id + '/fetch-list',

                // Limit the number of items which is shown at the list
                // (optional)
                limit: 0,
                minChars: false,
                // Highlight the first item in the list
                // (optional)
                selectFirst: false,

                // Override the default value (`q`) of query parameter name
                // Use a falsy value for RESTful query
                // (optional)
                queryParamName: 'search'
            }
        },

        methods: {
            preUpdate() {
                this.data = {
                    entity: $('select[name="comment_entity_type"]').val()
                };
                this.update();
            },

            update: function update() {
                var _this = this;
                if (this.minChars && this.query.length < this.minChars) {
                    return;
                }

                this.loading = true;

                this.fetch().then(function (response) {
                    var data = response.data;
                    data = _this.prepareResponseData ? _this.prepareResponseData(data) : data;
                    _this.items = _this.limit ? data.slice(0, _this.limit) : data;
                    _this.current = -1;
                    _this.loading = false;

                    if (_this.selectFirst) {
                        _this.down();
                    }
                });
            },

            reset () {
                this.items = [];
                this.loading = false;
                if (!this.selected) {
                    this.query = '';
                    return;
                }
                if (this.query == '') {
                    this.entity_id = '';
                    return;
                }
                this.query = this.selected.name;
                this.entity_id = this.selected.id;
            },

            // The callback function which is triggered when the user hits on an item
            onHit (item) {
                if (!item) return;
                this.selected = item;
                this.reset();
            },
        }
    }
</script>
